import { TrashIcon } from "@heroicons/react/24/outline";

export default function RemoveVendorFromListModal({
  isOpen,
  vendorName = "",
  vendorCount = 1,
  skippedCount = 0,
  onConfirm,
  onCancel,
  isSubmitting = false,
}) {
  if (!isOpen) return null;

  const count = Math.max(vendorCount, 1);
  const message =
    count === 1
      ? `Are you sure you want to remove \u201c${vendorName}\u201d from this list?`
      : `Are you sure you want to remove ${count} vendors from this list?`;

  return (
    <div
      className="fixed inset-0 z-50 overflow-y-auto"
      aria-labelledby="remove-vendor-from-list-title"
      role="dialog"
      aria-modal="true"
    >
      <div className="flex min-h-screen items-end justify-center px-4 pb-20 pt-4 text-center sm:block sm:p-0">
        <div
          className="fixed inset-0 backdrop-blur-sm transition-opacity"
          aria-hidden="true"
          onClick={isSubmitting ? undefined : onCancel}
        />
        <span className="hidden sm:inline-block sm:h-screen sm:align-middle" aria-hidden="true">
          &#8203;
        </span>
        <div className="relative inline-block transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left align-bottom shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg sm:p-6 sm:align-middle">
          <div className="sm:flex sm:items-start">
            <div className="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10">
              <TrashIcon className="h-6 w-6 text-red-600" aria-hidden="true" />
            </div>
            <div className="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
              <h3
                className="text-base font-semibold leading-6 text-gray-900"
                id="remove-vendor-from-list-title"
              >
                Remove from List
              </h3>
              <p className="mt-2 text-sm text-gray-500">{message}</p>
              {skippedCount > 0 ? (
                <p className="mt-2 text-sm text-amber-700">
                  {skippedCount} selected vendor{skippedCount === 1 ? "" : "s"} cannot be removed
                  and will be skipped.
                </p>
              ) : null}
            </div>
          </div>
          <div className="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
            <button
              type="button"
              disabled={isSubmitting}
              className="inline-flex w-full justify-center rounded-md bg-red-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-500 disabled:cursor-not-allowed disabled:opacity-60 sm:ml-3 sm:w-auto"
              onClick={onConfirm}
            >
              {isSubmitting ? "Removing…" : "Remove"}
            </button>
            <button
              type="button"
              disabled={isSubmitting}
              className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-60 sm:mt-0 sm:w-auto"
              onClick={onCancel}
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
